import { createBrowserHistory } from 'history';
import createApiClient from './api';
import createCookieManager from './cookie';
import createResourceManager from './resource';

const history = createBrowserHistory();
const historyFrouceUpdate = createBrowserHistory({ forceRefresh: true });
const api = createApiClient();
const cookie = createCookieManager();
const resource = createResourceManager();
const clearResourceCache = resource.clearCache;
const useResource = resource.useResource;

export { api, clearResourceCache, cookie, history, historyFrouceUpdate, resource, useResource };
